import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { Sidebar } from './Sidebar';

interface SnoozeFilterProps {
  onClose: () => void;
  onChange: (snoozeFilters: [boolean, boolean]) => void;
  selectedSnoozeFilters: [boolean, boolean];
  runFilter: () => void;
}

export const SnoozeFilter: React.FC<SnoozeFilterProps> = ({
  onClose,
  onChange,
  selectedSnoozeFilters,
  runFilter
}) => {
  const onChangeSnoozedFilter = (_evt: React.SyntheticEvent, val: boolean) => {
    const newSelectedSnoozeFilters: [boolean, boolean] = [val, selectedSnoozeFilters[1]];
    onChange(newSelectedSnoozeFilters);
  };

  const onChangeNotSnoozedFilter = (_evt: React.SyntheticEvent, val: boolean) => {
    const newSelectedSnoozeFilters: [boolean, boolean] = [selectedSnoozeFilters[0], val];
    onChange(newSelectedSnoozeFilters);
  };

  return (
    <Sidebar title="Snooze Status Filter" onClose={onClose} showDoneButton={false}>
      <div style={{ padding: 24 }}>
        <div>
          <FormControlLabel
            onChange={onChangeSnoozedFilter}
            control={<Checkbox />}
            label="Snoozed"
            checked={selectedSnoozeFilters[0]}
          />
        </div>
        <div>
          <FormControlLabel
            onChange={onChangeNotSnoozedFilter}
            control={<Checkbox />}
            label="Not snoozed"
            checked={selectedSnoozeFilters[1]}
          />
        </div>
      </div>
    </Sidebar>
  );
};
